import React from 'react';
import PropTypes from 'prop-types';

import PageContainer from '$components/PageContainer';
import Button from '$components/Button';

import { Container, Icon, Title, SubTitle } from './Error.styled';

const redirect = () => {
  window.location.href = '/';
};

const TYPES = {
  notFound: {
    testId: 'not-found-div',
    label: 'not found icon',
    title: "Sorry, we can't find that page",
    icon: '🕵',
    subTitle:
      'The link you follow could be broken, or the page may have been removed',
  },
  default: {
    testId: 'error-div',
    label: 'error icon',
    title: 'Oops, something went wrong',
    icon: '🤕',
    subTitle: 'Please try refreshing the page again in a moment',
  },
};

const Error = ({ type, hasSideBar }) => {
  const { testId, label, title, icon, subTitle } = TYPES[type] || TYPES.default;

  return (
    <PageContainer hasSideBar={hasSideBar}>
      <Container data-testid={testId}>
        <Icon role="img" aria-label={label}>
          {icon}
        </Icon>
        <Title>{title}</Title>
        <SubTitle>{subTitle}</SubTitle>
        <Button onClick={redirect}>Go home</Button>
      </Container>
    </PageContainer>
  );
};

Error.propTypes = {
  type: PropTypes.string,
  hasSideBar: PropTypes.bool,
};

Error.defaultProps = {
  type: 'default',
  hasSideBar: true,
};

export default Error;
